








































import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IAppraisal, Appraisal } from "@/models/appraisal.entity";
import TimeLineItemText from "@/components/utility/TimeLineItemText.vue";
import TimelineCard from "@/components/utility/TimelineItem.vue";

@Component({
  components: { TimeLineItemText, TimelineCard }
})
export default class AppraisalResponseCardHistory extends mixins(PermissionMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly formatCurrency = formatCurrency;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = Appraisal.statusIconMap;

  readonly statusColorMap = Appraisal.statusColorMap;

  @Prop()
  value!: IAppraisal;
}
